/**
 * EAA-1838: text helpers shared by the hierarchy screen's two "code" fields.
 *
 * `slugify` was module-private inside `useHierarchyPage` (EAA-1818, for the đơn vị
 * code). The unit-type quick-create needs the exact same transform for
 * `OrgUnitType.code`, and both fields are immutable after creation — so a second
 * copy would be a silent correctness risk the first time either is tweaked. It
 * lives here instead of in `dragRules.ts` (pure drop legality) or `types.ts`
 * (types only), and importing it from `useHierarchyPage` would have made that hook
 * and `useOrgUnitTypes` mutually dependent.
 */

/**
 * Vietnamese-aware slug: `"Trường A – Ôn thi"` -> `"truong-a-on-thi"`.
 *
 * `đ` is replaced BEFORE `NFD` normalization because its diacritic is a stroke
 * baked into the glyph, not a combining mark — decomposition leaves it intact and
 * the ASCII filter would then drop the letter entirely.
 */
export function slugify(input: string): string {
    return (
        input
            .toLowerCase()
            .replace(/đ/g, 'd')
            .normalize('NFD')
            // Strip combining diacritical marks (U+0300-U+036F) left behind by NFD
            // normalization — e.g. "Trường" -> "truong" instead of the raw NFD form.
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
    );
}
